import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import MemeEditor from "./pages/MemeEditor";
import ThankYou from "./pages/ThankYou";
import AdminPanel from "./pages/AdminPanel";
import AuthCallback from "./pages/AuthCallback";
import PublicGallery from "./pages/PublicGallery";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="editor" element={<MemeEditor />} />
            <Route path="done" element={<ThankYou />} />
            <Route path="gallery" element={<PublicGallery />} />
            <Route path="admin" element={<AdminPanel />} />
          </Route>
          <Route path="/auth/callback" element={<AuthCallback />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
